import { Helmet } from "react-helmet-async";

const SITE_URL = "https://pahi.co.in";
const DEFAULT_IMG = `${SITE_URL}/brand/pahi-logo.jpeg`;

const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMG,
  type = "website",
  schema,
}) => {
  const fullTitle = title
    ? `${title} | PAHI TECHNOCRATE PVT. LTD.`
    : "PAHI TECHNOCRATE PVT. LTD. | Precision Sheet Metal Manufacturing";
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="PAHI TECHNOCRATE PVT. LTD." />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
